// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const steenee: PokeData = {
  "id": 762,
  "name": "steenee",
  "height": 7,
  "weight": 82,
  "base_experience": 102,
  "types": [
    PokeType.GRASS
  ],
  "api_moves": [
    "double-slap",
    "stomp",
    "razor-leaf",
    "splash",
    "flail",
    "rapid-spin",
    "sweet-scent",
    "teeter-dance",
    "aromatherapy",
    "magical-leaf",
    "leaf-storm",
    "captivate",
    "play-nice",
    "aromatic-mist"
  ],
  "moves": [
    "razor-leaf",
    "splash",
    "aromatherapy",
    "vine-whip",
    "power-whip",
    "bullet-seed",
    "branch-poke",
    "grassy-terrain",
    "synthesis",
    "overgrowth",
    "frenzy-plant",
    "solar-beam",
    "leaf-tornado"
  ],
  "evolution_chain": {
    "id": 392,
    "item": null,
    "species": [
      {
        "name": "bounsweet",
        "order": 761,
        "types": [
          PokeType.GRASS
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "steenee",
        "order": 762,
        "types": [
          PokeType.GRASS
        ],
        "evolves_from_species_id": 761,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 18,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      },
      {
        "name": "tsareena",
        "order": 763,
        "types": [
          PokeType.GRASS
        ],
        "evolves_from_species_id": 762,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": null,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": {
              "name": "stomp"
            },
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 50,
    "speed": 62,
    "ability_power": 40
  },
  "stat_changes": [],
  "catch_rate": 120,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
